/**
 * Empty-state hint shown when the user has no template selected.
 * Summary/note generation requires a template, so this explains why the
 * generate button is disabled and offers the quickest ways to fix it.
 */

import { Button } from '@/components/ui/button';
import { FileCode } from 'lucide-react';
import { Link } from 'wouter';

interface TemplateRequiredHintProps {
  noun: 'samantekt' | 'nótu';
  verb?: 'búa til' | 'endurgera';
  // Omitted when no template selector is rendered (templates still loading or none available).
  onOpenSelector?: () => void;
}

export const TemplateRequiredHint = ({ noun, verb = 'búa til', onOpenSelector }: TemplateRequiredHintProps) => (
  <div className="space-y-2 text-muted-foreground text-sm">
    <p>
      Veldu sniðmát til að {verb} {noun}.
    </p>
    {onOpenSelector && (
      <Button variant="ghost" size="sm" className="h-7 gap-1 text-xs" onClick={onOpenSelector}>
        <FileCode className="h-3.5 w-3.5" /> Veldu sniðmát
      </Button>
    )}
    <p className="text-xs">
      Þú getur stillt sjálfgefið sniðmát á síðunni{' '}
      <Link href="/templates" className="underline underline-offset-2 hover:text-foreground">
        Sniðmát
      </Link>
      .
    </p>
  </div>
);
